<template>
    <el-dialog :title="title" :visible.sync="visible" @close="close">
        <div>
            <receipt-cfg-page ref="page" @selected-change="handleSelectedChange" />
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel" size="small">取 消</el-button>
            <el-button @click="confirm" size="small" type="primary">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import ReceiptCfgPage from './receipt-cfg-page';

    export default {
        name: "receipt-cfg-page-dialog",
        components: {
            ReceiptCfgPage,
        },
        props: {
            title: {
                default: '收款账号选择'
            }
        },
        data() {
            return {
                visible: false,
                selected: null,
            };
        },
        computed: {
        },
        watch: {

        },
        methods: {
            handleSelectedChange(selected) {
                this.selected = selected;
            },
            async open() {
                if (this.$refs.page != null) {
                    this.$refs.page.resetPageSearch();
                }
                this.visible = true;
            },
            close() {
                this.visible = false;
            },
            cancel() {
                this.visible = false;
            },
            confirm() {
                if (this.selected == null) {
                    this.$message.error('请选择一条记录');
                    return;
                }
                this.visible = false;
                this.$emit('confirm', this.selected);
            },
        },
    }
</script>

<style scoped>

</style>